export class MotorType {

  motorCode!: string;
  guruModelValue!: string;
  description!: string;

}
